import type { FC } from 'react';
import { useParams } from 'wouter';
import { Redirect, useLocation } from '@/base/router';
import { DocPage } from '@/docs/DocPage';
import { GuidePage } from '@/docs/GuidePage';
import { pages } from '@/docs/pages';
import { ContactPage } from '@/landing/ContactPage';
import { LandingPage } from '@/landing/LandingPage';
import { CoinBuyPage, CoinPricePage } from '@/markets/coin/CoinPageTypeWrapper';
import { BuyPage, PricesPage } from '@/markets/MarketPageWrapper';
import { useSettings } from '@/settings/api';
import { ClientOnly } from '@/shared/ClientOnly';
import { usePupeteerSignal } from '@/shared/usePupeteerSignal';
import { IS_PRERENDERING } from '../modules/base/constants';
import { ConverterPage } from '../modules/landing/ConverterPage';
import { OnboardingPage } from '../modules/landing/OnboardingPage';
import { getIsTelegramMiniApp, isStandalone } from '../modules/shared/js';

const FallbackPage: FC = () => {
  const [{ language }] = useSettings();
  const [location] = useLocation();
  usePupeteerSignal(true);
  if (location.split('/').filter((x) => !!x)[0] !== language) {
    return (
      <ClientOnly>
        <Redirect
          workspace="public"
          to={`/${language}${location.startsWith('/') ? location.slice(1) : location}`}
        />
      </ClientOnly>
    );
  }
  throw new Error('404:Page not Found');
};

// todo: this is wrong and temporary. change app start url from / to /app!
const DynamicLandingPage: FC = () => {
  const shouldShowOnboarding =
    (isStandalone() || getIsTelegramMiniApp()) && !IS_PRERENDERING;
  const landing = <LandingPage />;
  return (
    <ClientOnly fallback={landing}>
      {shouldShowOnboarding ? <OnboardingPage /> : landing}
    </ClientOnly>
  );
};

// Standalone markdown pages from src/modules/docs/pages. Registered after the
// regular routes so those always win over a page with the same name; unknown
// slugs keep the FallbackPage behavior (language redirect / 404).
const DocOrFallbackPage: FC = () => {
  const { page } = useParams<{ page: string }>();
  return Object.hasOwn(pages, page) ? <DocPage /> : <FallbackPage />;
};

console.log(pages);

export const routes = {
  '/:lang': DynamicLandingPage,
  '/:lang/converter/:from/:to': ConverterPage,
  '/:lang/contact-us': ContactPage,
  '/:lang/buy-and-sell': BuyPage,
  '/:lang/buy-and-sell/:slug': CoinBuyPage,
  '/:lang/price': PricesPage,
  '/:lang/price/:slug': CoinPricePage,
  '/:lang/guide': GuidePage,
  '/:lang/:page': DocOrFallbackPage,
  '/*': FallbackPage,
};

export const base = undefined;
